<template>
	<div class='knd-header'>
		<div class=' knd-container'>		
			<h2 class='knd-header-title knd-ta-center knd-m-b-md'>
				<span class=''>{{general.title}}</span>
			</h2>

			<div class='knd-header-leader knd-m-b-md knd-ta-center '>
				In <span class='knd-header__highlight knd_aantal_onderzoek'>{{$store.state.onderzoek}}</span> van de <span class='knd-bold'>{{$store.state.totaalgemeenten}}</span> gemeenten die genoemd worden in de Vastgoedboeken wordt onderzoek gedaan. 
				Daarvan zijn er <span class='knd-header__highlight knd_aantal_afgerond'>{{$store.state.afgerond}}</span> afgerond.

			</div>
			<div class='knd-header-date knd-ta-center knd-font-sm'>
				<span class='knd-bold'>laatste update</span> {{general.datumFormatted}}
			</div>	
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Articles',
		data() {
			return {
				general: this.$store.state.general,
				aantal_onderzoeken: 55,
				aantal_gemeenten: 224,
				aantal_afgerond: 9,
			};
		},
		methods: {}
	}
</script>